<template>
  <div>
    <v-dialog
      v-model="changeNextReceiptDateDialog"
      persistent
      max-width="500px"
      transition="slide-y-transition"
    >
      <v-card class="dialog-card-border">
        <v-card-title class="text-h6">
          <div class="col-12 pa-0">
            {{ $t('Change next receipt date for') }}
          </div>
          <div class="error--text col-12 pa-0">
            {{ formData.customer_name }}
          </div>
        </v-card-title>

        <validation-observer
          ref="theForm"
          v-slot="{ handleSubmit, reset }"
        >
          <form
            autocomplete="off"
            @submit.prevent="handleSubmit(submit)"
            @reset.prevent="reset"
          >
            <v-card-text>
              <v-row no-gutters>
                <v-col
                  class="px-1"
                  cols="12"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    :name="$t('Date')"
                    rules="required"
                  >
                    <app-date-picker
                      v-model="formData.next_receipt_date"
                      :label="`* ${$t('Date')}`"
                      outlined
                      dense
                      no-title
                      :color="$_input_color()"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions class="py-3">
              <app-form-tip />

              <v-spacer />

              <v-btn
                depressed
                outlined
                small
                @click="closeDialog()"
              >
                {{ $t('Cancel') }}
              </v-btn>

              <app-submit-button edit-mode />
            </v-card-actions>
          </form>
        </validation-observer>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    changeNextReceiptDateDialog: { type: Boolean, default: false },
    formData: { type: Object, default: () => { } },
  },

  methods: {
    closeDialog() {
      this.$refs.theForm.reset()
      this.$emit('close')
    },

    submit() {
      axios.put(`monthly-plan/${this.formData.id}/update-next-receipt-date/`, this.formData).then(() => {
        this.$_notify('Updated successfully')
        this.closeDialog()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>